(function($){
        $(document).ready(function(){
           var height=  $('body .grid-img-slider .slider-wrapper .col').matchHeight();
            var $parent = $(".grid-img-slider .slider-wrapper");
            var itemLength = $(".grid-img-slider .slider-wrapper .image").length;
            for (var i = 0; i < itemLength; i++) {
                if ((i == 0) || (i % 3 == 0)) {
                    n = i + 1;
                    var row = $parent.find(".image").slice(i, n);
                    row.wrapAll("<div class='col col-lg-7'></div>");
                }else if((i == 1) || (i % 3 == 1)){
                    n = i + 2;
                    var row = $parent.find(".image").slice(i, n);
                    row.wrapAll("<div class='col col-lg-5'></div>");
                }
            }
            $('.grid-img-slider .slider-wrapper').slick({
                centerPadding: '30px',
                slidesToShow: 2,
                variableWidth: true,
                infinite: true,
                arrows: false,
                speed: 700,
                autoplay: true,
                autoplaySpeed: 3500,
                pauseOnHover: true,
                pauseOnFocus: false,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            centerPadding: '30px'
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            variableWidth: false,
                            centerMode: true,
                            centerPadding: '60px',
                            slidesToShow: 1,
                            focusOnSelect: true,

                        }
                    },
                    {
                        breakpoint: 595,
                        settings: {
                            variableWidth: false,
                            centerMode: true,
                            centerPadding: '20px',
                            slidesToShow: 1,
                            focusOnSelect: true,

                        }
                    }
                ]
            });
        });
})(jQuery);